/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateBusinessChowlyBody
 */
export interface UpdateBusinessChowlyBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessChowlyBody
     */
    chowlyApi: string;
}

export function UpdateBusinessChowlyBodyFromJSON(json: any): UpdateBusinessChowlyBody {
    return UpdateBusinessChowlyBodyFromJSONTyped(json, false);
}

export function UpdateBusinessChowlyBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBusinessChowlyBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'chowlyApi': json['chowlyApi'],
    };
}

export function UpdateBusinessChowlyBodyToJSON(value?: UpdateBusinessChowlyBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'chowlyApi': value.chowlyApi,
    };
}


